import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import addicon from "../../assets/images/addicon.svg";
import copyicon from "../../assets/images/copyIcon.svg";
import removeicon from "../../assets/images/deleteaction.svg";
import { default as infoIcon } from "../../assets/images/infobtnblue.svg";
import {
  detailsbyhooktype,
  generatetoken,
  makehook,
} from "../../services/ReduxTookit/Slice/WebhookDetailsRedux";
// import SubmitLoading from "../../../common-component/Loaders/SubmitLoading";
import DeleteModal from "../../Modals/DeleteModal";
import { API_URL } from "../../services/APIRoute";
import SubmitLoading from "./Loaders/SubmitLoading";
import Loader, { LoaderType } from "./Loader";
import { toast } from "react-toastify";
import { commonservices } from "../../services/CommonServices";
import MainpageLoader from "./Loaders/MainpageLoader";

const WebhookCommon = ({
  isViewMode,
  hooktype,
  associationid,
  associationtype,
  // setEnableWebhook,
}) => {
  const dispatch = useDispatch();
  const [DetailLoader, setDetailLoader] = useState(false);
  const [WebhookLoader, setWebhookLoader] = useState(false);
  const [EnableWebhook, setEnableWebhook] = useState(false);
  const [WebhookDetails, setWebhookDetails] = useState({
    webhookdetailid: 0,
    returnurl: [""],
    ipaddress: [""],
    url: "",
    key: "",
    returnurlValidation: [""],
    ipaddressValidation: [""],
  });

  const [WebhookDeleteConfirmation, setWebhookDeleteConfirmation] =
    useState(false);
  const [WebhookDeletePayload, setWebhookDeletePayload] = useState(false);
  function fnAddReturnUrl() {
    let _WebhookDetails = { ...WebhookDetails };
    _WebhookDetails.returnurlValidation = [];
    _WebhookDetails.returnurl.push("");
    setWebhookDetails(_WebhookDetails);
  }
  function fnRemoveReturnUrl(index) {
    let _WebhookDetails = { ...WebhookDetails };
    if (index > -1) {
      _WebhookDetails.returnurl.splice(index, 1);
    }
    setWebhookDetails(_WebhookDetails);
  }
  function fnChangeRetrunURLValue(value, index) {
    let _WebhookDetails = { ...WebhookDetails };
    if (index > -1) {
      _WebhookDetails.returnurl[index] = value;
      _WebhookDetails.returnurlValidation[index] = "";
    }
    setWebhookDetails(_WebhookDetails);
  }
  function fnAddIPAddress() {
    let _WebhookDetails = { ...WebhookDetails };
    _WebhookDetails.ipaddressValidation = [];
    _WebhookDetails.ipaddress.push("");
    setWebhookDetails(_WebhookDetails);
  }
  function fnRemoveIPAddress(index) {
    let _WebhookDetails = { ...WebhookDetails };
    if (index > -1) {
      _WebhookDetails.ipaddress.splice(index, 1);
    }
    setWebhookDetails(_WebhookDetails);
  }
  function fnChangeIPAddressValue(value, index) {
    let _WebhookDetails = { ...WebhookDetails };
    if (index > -1) {
      _WebhookDetails.ipaddress[index] = value;
      _WebhookDetails.ipaddressValidation[index] = "";
    }
    setWebhookDetails(_WebhookDetails);
  }
  useEffect(() => {
    if (associationid) {
      GetDetailsByHookType();
    }
  }, [associationid]);
  function GetDetailsByHookType() {
    setDetailLoader(true);
    let _WebhookDetails = { ...WebhookDetails };
    _WebhookDetails.returnurlValidation = [];
    _WebhookDetails.ipaddressValidation = [];
    _WebhookDetails.webhookdetailid = 0;
    _WebhookDetails.returnurl = [""];
    _WebhookDetails.ipaddress = [""];
    _WebhookDetails.url = "";
    _WebhookDetails.key = "";
    setWebhookDetails(_WebhookDetails);
    dispatch(
      detailsbyhooktype({
        hooktype: hooktype,
        associationid: associationid,
        associationtype: associationtype,
      }),
    ).then((response) => {
      if (response?.payload?.isValidate) {
        setDetailLoader(false);
        BindDataWebhookDataInState(response);
      }
      if (!response?.payload?.isValidate) {
        setDetailLoader(false);
      }
    });
  }

  useEffect(() => {
    if (WebhookDetails.url && WebhookDetails.key) {
      setEnableWebhook(true);
    }
  }, [WebhookDetails]);
  function BindDataWebhookDataInState(response) {
    let _WebhookDetails = { ...WebhookDetails };
    _WebhookDetails.returnurlValidation = [];
    _WebhookDetails.ipaddressValidation = [];
    _WebhookDetails.webhookdetailid =
      response?.payload.data.data.webhookdetailid;

    if (response?.payload.data?.data?.returnurl) {
      let returnurl = response?.payload.data?.data?.returnurl.split("\n");
      if (returnurl) {
        _WebhookDetails.returnurl = [];
        returnurl.map((item) => {
          if (item) {
            _WebhookDetails.returnurl.push(item);
          }
        });
      }
    }

    if (response?.payload.data?.data?.ipaddress) {
      let ipaddress = response?.payload.data?.data?.ipaddress.split("\n");
      if (ipaddress) {
        _WebhookDetails.ipaddress = [];
        ipaddress.map((item) => {
          if (item) {
            _WebhookDetails.ipaddress.push(item);
          }
        });
      }
    }

    if (response?.payload.data?.data?.tokenkey) {
      let tokenkey = response?.payload.data?.data?.tokenkey.split("?token=");
      if (tokenkey) {
        _WebhookDetails.url = response?.payload.data?.data?.tokenkey;
        _WebhookDetails.key = tokenkey[1];
      }
    }

    setWebhookDetails(_WebhookDetails);
  }
  useEffect(() => {
    const cleanup = commonservices.setupKeyPressHandler(fnSaveWebHook);
    return cleanup;
  }, [fnSaveWebHook]);

  function fnSaveWebHook(e) {
    e.preventDefault();
    let IsDataValid = true;
    let _WebhookDetails = { ...WebhookDetails };
    _WebhookDetails.returnurlValidation = [];
    _WebhookDetails.ipaddressValidation = [];
    _WebhookDetails.returnurl.map((item) => {
      if (item) {
        var reg = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-]*)*$/;
        if (!item.match(reg)) {
          _WebhookDetails.returnurlValidation.push("Enter valid URL");
          IsDataValid = false;
        } else {
          _WebhookDetails.returnurlValidation.push("");
        }
      } else {
        _WebhookDetails.returnurlValidation.push("This field is a required");
        IsDataValid = false;
      }
    });

    _WebhookDetails.ipaddress.map((item) => {
      if (item) {
        var reg =
          /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        if (!item.match(reg)) {
          _WebhookDetails.ipaddressValidation.push("Enter valid ip address");
          IsDataValid = false;
        } else {
          _WebhookDetails.ipaddressValidation.push("");
        }
      } else {
        _WebhookDetails.ipaddressValidation.push("This field is a required");
        IsDataValid = false;
      }
    });
    setWebhookDetails(_WebhookDetails);

    if (IsDataValid) {
      setWebhookLoader(true);
      let returnurl = "";
      let ipaddress = "";
      WebhookDetails.returnurl.map((item) => {
        if (item) {
          returnurl = returnurl + (returnurl ? "\n" : "") + item;
        }
      });

      WebhookDetails.ipaddress.map((item) => {
        if (item) {
          ipaddress = ipaddress + (ipaddress ? "\n" : "") + item;
        }
      });

      dispatch(
        makehook({
          webhookdetailid: WebhookDetails.webhookdetailid,
          hooktype: hooktype,
          returnurl: returnurl,
          associationid: associationid,
          associationtype: associationtype,
          ipaddress: ipaddress,
        }),
      ).then((response) => {
        setWebhookLoader(false);
        if (response?.payload?.isValidate) {
          BindDataWebhookDataInState(response);
        }

        if (!response?.payload?.isValidate) {
        }
      });
    }
  }

  function fnReGenerateWebHookKey() {
    if (
      WebhookDetails.webhookdetailid &&
      parseInt(WebhookDetails.webhookdetailid) > 0
    ) {
      setWebhookLoader(true);

      dispatch(
        generatetoken({
          id: WebhookDetails.webhookdetailid,
        }),
      ).then((response) => {
        setWebhookLoader(false);
        if (response?.payload?.isValidate) {
          BindDataWebhookDataInState(response);
        }

        if (!response?.payload?.isValidate) {
        }
      });
    }
  }

  function fnDeleteWebHookKey() {
    if (
      WebhookDetails.webhookdetailid &&
      parseInt(WebhookDetails.webhookdetailid) > 0
    ) {
      setWebhookDeletePayload({
        id: WebhookDetails.webhookdetailid,
      });
      setWebhookDeleteConfirmation(true);
    }
  }

  function CopyClipBoard(event, value) {
    navigator.clipboard.writeText(value);
    toast.success("Copied successfully!");
  }
  return (
    <>
      {WebhookLoader && <MainpageLoader />}
      {EnableWebhook ? (
        <>
          {" "}
          <Row>
            {DetailLoader ? (
              <div className="mb-3">
                <Loader type={LoaderType.Line} count={3} />
              </div>
            ) : (
              <>
                <Col xl={12}>
                  <Form.Group className="form-group mb-2">
                    <Form.Label className="login-label">Return URL</Form.Label>
                    {WebhookDetails.returnurl.map((item, index) => {
                      return (
                        <div className="weebhook-url-add-box">
                          <div class="position-relative webhookaddicon-inner">
                            <Form.Control
                              type="text"
                              id={"txtreturnurl_" + (index + 1)}
                              placeholder="Return URL"
                              className="common-input"
                              value={item}
                              onChange={(e) =>
                                fnChangeRetrunURLValue(e.target.value, index)
                              }
                              isInvalid={
                                WebhookDetails.returnurlValidation[index]
                              }
                            />
                            {WebhookDetails.returnurlValidation[index] && (
                              <Form.Control.Feedback type="invalid">
                                <span className="error-message-icon">
                                  <img
                                    src={infoIcon}
                                    alt="infoIcon"
                                    title={
                                      WebhookDetails.returnurlValidation[index]
                                    }
                                  />
                                </span>
                              </Form.Control.Feedback>
                            )}
                          </div>
                          <div className="addicon-setdata">
                            {WebhookDetails.returnurl.length === index + 1 ? (
                              <img
                                className={"action"}
                                src={addicon}
                                alt=""
                                id={"btnreturnurl_" + (index + 1)}
                                onClick={(e) => fnAddReturnUrl()}
                              />
                            ) : (
                              <img
                                className={"action"}
                                src={removeicon}
                                alt=""
                                id={"btnreturnurl_" + (index + 1)}
                                onClick={(e) => fnRemoveReturnUrl(index)}
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </Form.Group>
                </Col>
                <Col xl={12}>
                  <Form.Group className="form-group mb-2">
                    <Form.Label className="login-label">IP Address</Form.Label>
                    {WebhookDetails.ipaddress.map((item, index) => {
                      return (
                        <div className="weebhook-url-add-box">
                          <div class="position-relative webhookaddicon-inner">
                            <Form.Control
                              type="text"
                              id={"txtipaddress_" + (index + 1)}
                              placeholder="IP Address"
                              className="common-input"
                              value={item}
                              onChange={(e) =>
                                fnChangeIPAddressValue(e.target.value, index)
                              }
                              isInvalid={
                                WebhookDetails.ipaddressValidation[index]
                              }
                            />
                            {WebhookDetails.ipaddressValidation[index] && (
                              <Form.Control.Feedback type="invalid">
                                <span className="error-message-icon">
                                  <img
                                    src={infoIcon}
                                    alt="infoIcon"
                                    title={
                                      WebhookDetails.ipaddressValidation[index]
                                    }
                                  />
                                </span>
                              </Form.Control.Feedback>
                            )}
                          </div>
                          <div className="addicon-setdata">
                            {WebhookDetails.ipaddress.length === index + 1 ? (
                              <img
                                className={"action"}
                                src={addicon}
                                alt=""
                                id={"btnipaddress_" + (index + 1)}
                                onClick={(e) => fnAddIPAddress()}
                              />
                            ) : (
                              <img
                                className={"action"}
                                src={removeicon}
                                alt=""
                                id={"btnipaddress_" + (index + 1)}
                                onClick={(e) => fnRemoveIPAddress(index)}
                              />
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </Form.Group>
                </Col>
              </>
            )}
            <Col xl={12}>
              <Form.Group className="form-group mb-2">
                <button class="blue-btn" onClick={(e) => fnSaveWebHook(e)}>
                  {WebhookLoader ? <SubmitLoading /> : "Save"}
                </button>
              </Form.Group>
            </Col>
          </Row>
          {/* </div> */}
          {WebhookLoader ? (
            <div className="my-2">
              <Loader type={LoaderType.Line} count={3} />
            </div>
          ) : (
            <>
              {(WebhookDetails.url || WebhookDetails.key) && (
                <>
                  <hr className="m-0 p-0"></hr>
                  <h6 className="mt-2">Preview</h6>
                  <div className="ms-0 ps-0 p-2">
                    <Row>
                      <Col xl={12} className="pe-0">
                        <Form.Group className="form-group mb-2">
                          <Form.Label className="login-label">URL</Form.Label>
                          <Row>
                            <Col xl={12} className={"mb-2"}>
                              <div class="position-relative webhookcopy-inner">
                                <Form.Control
                                  type="text"
                                  disabled={true}
                                  value={WebhookDetails.url}
                                />
                                <img
                                  className={
                                    "action webhookcopy cursor-pointer"
                                  }
                                  src={copyicon}
                                  alt=""
                                  onClick={(e) =>
                                    CopyClipBoard(e, WebhookDetails.url)
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                      </Col>
                      <Col xl={12} className="pe-0">
                        <Form.Group className="form-group mb-2">
                          <Form.Label className="login-label">Key</Form.Label>
                          <Row>
                            <Col xl={12} className={"mb-2"}>
                              <div class="position-relative webhookcopy-inner">
                                <Form.Control
                                  type="text"
                                  disabled={true}
                                  value={WebhookDetails.key}
                                />
                                <img
                                  className={
                                    "action webhookcopy cursor-pointer"
                                  }
                                  src={copyicon}
                                  alt=""
                                  onClick={(e) =>
                                    CopyClipBoard(e, WebhookDetails.key)
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                      </Col>
                      <Col xl={12}>
                        <Row>
                          <Col xl={6} className="pe-0">
                            <Form.Group className="form-group mb-1">
                              <button
                                class="blue-btn"
                                onClick={(e) => fnReGenerateWebHookKey()}
                              >
                                {WebhookLoader ? (
                                  <SubmitLoading />
                                ) : (
                                  "Re-Generate Key"
                                )}
                              </button>
                            </Form.Group>
                          </Col>
                          <Col xl={6} className="pe-0">
                            <Form.Group className="form-group mb-1">
                              <button
                                class="red-btn deletewebhook"
                                onClick={(e) => fnDeleteWebHookKey()}
                              >
                                {WebhookLoader ? (
                                  <SubmitLoading />
                                ) : (
                                  "Delete Webhook"
                                )}
                              </button>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <div className="twofactor-profile">
          <h3>Enhance Your Integration with Webhooks</h3>
          <p>
            Seamlessly connect your applications by enabling Webhooks. This
            simple, real-time setup allows you to receive instant updates and
            automate workflows by sending data to your specified endpoint
            whenever an event occurs.
          </p>

          <div className="d-flex justify-content-center">
            <button
              className="green-btn "
              disabled={isViewMode}
              onClick={() => {
                setEnableWebhook(true);
                // setPasswordWalletState(true);
              }}
            >
              Enable Webhook
            </button>
          </div>
        </div>
      )}

      {WebhookDeleteConfirmation && (
        <DeleteModal
          payload={WebhookDeletePayload}
          url={API_URL.WEBHOOKDETAILS.DELETEHOOK}
          show={WebhookDeleteConfirmation}
          bindlist={GetDetailsByHookType}
          onHide={(e) => setWebhookDeleteConfirmation(false)}
          isdeleteWebhookmodelClass={true}
        />
      )}
    </>
  );
};

export default WebhookCommon;
